import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCustomers() {
        return axios
            .get('/customers/customers?hasOutdoorLocalizations=true')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy klientów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getTeams(context, {
        query = '',
    } = {}) {
        return axios
            .get(`/outdoors/outdoor-localization-teams${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ekip nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getLocalizations(context, { query }) {
        return axios
            .get(`/outdoors/outdoor-localizations-coordinates${query}&limit=5000`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
}